<template>
  <div>
    <ExistenciasModalComponent />
    <div class="row">
      <!-- Boton de acciones flotantes start  -->
      <div class="fab fab-12">
        <div @click="abrirModalOpciones()" class="btn-round">
          <i id="addIcon"><i class="fas fa-bars"></i></i>
        </div>
      </div>
      <!-- Boton de acciones flotantes END  -->
      <div class="col-12">
        <div
          class="modal fade"
          id="modalExistencias"
          role="dialog"
          tabindex="-1"
          aria-hidden="true"
          style="display: none"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Inventario en estación</h5>
                <button
                  aria-label="Close"
                  class="close"
                  data-dismiss="modal"
                  type="button"
                >
                  <span aria-hidden="true"> ×</span>
                </button>
              </div>
              <div class="modal-body">
                <table class="table table-compact smaller text-faded mb-0">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th>Lote</th>
                      <th>Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="existencia in existencias" :key="existencia.id">
                      <td class="text-bright">
                        {{ existencia.sku }} - {{ existencia.nombre_sku }}
                      </td>
                      <td class="text-right">
                        {{ existencia.codigo_lote }}
                      </td>
                      <td
                        v-bind:class="{
                          'text-danger': existencia.cantidad < 0,
                        }"
                        class="text-right text-success"
                      >
                        {{ existencia.cantidad }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InventarioPosicionProductoModalComponent />
      <div class="col-12" v-if="error_finalizar">
        <small class="form-text text-danger">
          {{ error_finalizar }}
        </small>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalOpciones"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              class="activity-box btn-sm btn-block btn-danger"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="finalizarTarima()"
            >
              <div class="activity-avatar">
                <i class="fas fa-check"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Finalizar Tarima</span>
              </div>
            </button>
            <hr />
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="Imprimir(id_tarima)"
            >
              <div class="activity-avatar">
                <i class="fas fa-print"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Imprimir</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="verInventarioDeEstacion()"
            >
              <div class="activity-avatar">
                <i class="fa fa-cubes"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Inventario de Estación</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="inventarioXposicionXproducto()"
            >
              <div class="activity-avatar">
                <i class="fa fa-cubes"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Inv de posición producto</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="anularTarima()"
            >
              <div class="activity-avatar">
                <i class="fas fa-ban"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Anular Tarima</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import InventarioPosicionProductoModalComponent from "@/components/commons/InventarioPosicionProductoModalComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";

export default {
  components: {
    InventarioPosicionProductoModalComponent,
    ExistenciasModalComponent,
  },
  props: {
    id_tarima: {
      type: String,
    },
  },
  data() {
    return {
      barra_estacion: "",
      error_estacion: null,
      error_finalizar: null,
      existencias: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    abrirModalOpciones() {
      $("#modalOpciones").modal("show");
    },
    inventarioXposicionXproducto() {
      $("#modalOpciones").modal("hide");
      $("#modalInventarioXposicionXproducto").modal("show");
    },
    Imprimir(current) {
      let self = this;
      $("#modalOpciones").modal("hide");
      self.id = current.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    anularTarima() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "Anular Tarima?",
        "Esta seguro que quiere anular la tarima?",
        "si, Anular",
        function () {
          DynamicService.postAction("wms", "tarima", self.id_tarima, "anular")
            .then((response) => {
              Notifications.alert.success(
                "Anular Tarima",
                "la tarima fue anulada con éxito"
              );
              self.$emit("refresh_tarima_finalizada");
            })
            .catch((err) => {
              if (err.response.data.detail) {
                Notifications.alert.error(
                  "Anular Tarima",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
    verInventarioDeEstacion() {
      let self = this;
      $("#modalOpciones").modal("hide");
      $("#modalBarraPosicion").modal("show");
    },
    finalizarTarima() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm_danger(
        "¿Desea finalizar la tarima?",
        "¿Quiere seguir con finalizar la tarima?",
        "",
        function () {
          $("#modalOpciones").modal("hide");
          DynamicService.postAction(
            "wms",
            "tarima",
            self.id_tarima,
            "finalizar_tarima",
            {}
          )
            .then((res) => {
              self.$emit("refresh_tarima_finalizada");
              self.error_finalizar = "";
            })
            .catch((err) => {
              console.log(err.response.data);
              if (err.response.data.detail) {
                Notifications.alert.error(
                  "Finalizar Tarima",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
  },
};
</script>
